import React, {useEffect} from 'react';
import {Venue} from '~/data/umbraco/types/common';
import {venueThemeToColor} from '~/lib/ui';
import useThemeStore from '~/store/themeStore';

type Props = {
  venue: Venue | null;
};

const ThemeStorage: React.FC<Props> = (props) => {
  const {venue} = props;

  useEffect(() => {
    useThemeStore.setState({
      isVenue: Boolean(venue),
      theme: venueThemeToColor(venue || ''),
    });

    if (!venue) {
      useThemeStore.setState({
        bannerDirectionsLink: null,
        bannerPhone: null,
        bannerEmail: null,
        themeLogo: null,
        link: null,
        linkIcon: null,
      });
    }
  }, [venue]);

  return null;
};

export default ThemeStorage;
